// Seeded from the clock so a new session always starts higher than the one a reload discarded.
let counter = Date.now() * 1000

export function nextOptimisticVersion(): number {
  return ++counter
}
